import { Button, Col, Row, Typography } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { CloseIcon } from '../../../../shared/icons/close-icon';
import { FullscreenIcon } from '../../../../shared/icons/fullscreen-icon';
import styles from './request-preview-sider-header.module.css';

interface Props {
  submenuTitle: string;
  closePreview: () => void;
  fullscreenUrl: string;
}

const RequestPreviewSiderHeader = ({ submenuTitle, closePreview, fullscreenUrl }: Props): JSX.Element => {
  const location = useLocation();

  return (
    <Row className={styles.submenuHeader} justify="space-between" align="middle">
      <Col>
        <Row align="middle" gutter={8}>
          <Col>
            <Typography className={styles.title}>{submenuTitle}</Typography>
          </Col>
          <Col>
            <Link to={fullscreenUrl} className={styles.fullscreenLink} state={{ from: location }}>
              <FullscreenIcon />
            </Link>
          </Col>
        </Row>
      </Col>
      <Col>
        <Button onClick={closePreview} type="text" icon={<CloseIcon />}></Button>
      </Col>
    </Row>
  );
};

export default RequestPreviewSiderHeader;
